import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { DownloadListModel, FileType } from '@libs/cms/models';
import { IconName } from '@libs/shared/models';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlinesComponent,
    IconComponent,
  ],
})
export class DownloadListComponent extends ContentBaseComponent<DownloadListModel> {
  public readonly genericFileIcon: IconName = 'file';

  public readonly fileIcons: Partial<Record<FileType, IconName>> = {
    document: 'file-lines',
    image: 'file-image',
    video: 'file-video',
  };
}
